import Heading from '@amzn/meridian/heading';
import { localize } from './localize';

export default localize(Heading, ['children']);
